const GATEWAY_CODE = {
  10000: '请求成功',
  10101: '用户名或密码错误',
  10102: '验证码错误',
  10103: '获取验证码失败',
  10104: '用户未登录',
  10201: '登出异常',
  10301: '参数不对',
  10401: '无权限',
  10501: 'token过期或者格式不对',
  20000: '请求失败',
  20001: '未知错误',
  '0000': '请求成功'
}

/**
 * 校验网关返回结果code
 * **/
function checkGetwayCode (code) {
  return code === 10000 || code === '0000'
}

function getGetwayInfo (code) {
  return GATEWAY_CODE[code]
}
export default {
  checkGetwayCode,
  getGetwayInfo
}



// WEBPACK FOOTER //
// ./src/libs/global.js